(function () {

    'use strict';

    const angular = require('angular');
    const FormsContainerCtrl = require("./controllers/FormsContainerCtrl");
    const FormDetailCtrl = require("./controllers/FormDetailCtrl");

    const formsService = require("./services/formsService");

    const formTemplate = require('./components/form-template');

    angular
        .module("medinet")

        .component('formTemplate', formTemplate)

        .service('formsService', formsService)
        .controller('FormsContainerCtrl', FormsContainerCtrl)
        .controller('FormDetailCtrl', FormDetailCtrl);


})();